export default __webpack_public_path__ + "static/media/logo.39e2eb3a.svg";